import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import cloneDeep from 'lodash-es/cloneDeep';
import { NavHeaderConfig, PipNavService } from 'pip-webui2-nav';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApplicationGroupTile, ApplicationTile, ApplicationUrlType } from './../../../applications/models/index';
import { GaApplicationsService } from './../../../applications/services/applications.service';
import { NameableSubscription, trackBy, UnsubscriberHandler } from './../../../common/index';
import { GaSessionService } from './../../../session/services/session.service';

@Component({
    selector: 'ga-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GaSidenavComponent implements OnChanges, OnDestroy {

    @UnsubscriberHandler()
    private subs: NameableSubscription;
    private defaultFixedApplications: { [key: string]: ApplicationTile } = {
        home: {
            id: 'pg-home',
            name: {
                en: 'Home',
                ru: 'ÐÐ»Ð°Ð²Ð½Ð°Ñ'
            },
            description: {
                en: 'Home application',
                ru: 'ÐÐ»Ð°Ð²Ð½Ð°Ñ ÑÑÑÐ°Ð½Ð¸ÑÐ°'
            },
            product: 'Guru Admin',
            group: null,
            url: {
                type: ApplicationUrlType.Inner,
                link: '/home/index.html#'
            },
            icon: '{"fontIcon": "home"}',
            iconView: {
                fontIcon: 'home'
            },
            params: {
                basic: true
            }
        }
    };
    private fixedPrependApplicationsKeys = ['home'];
    private fixedAppendApplicationsKeys = [];

    public activeApplicationId: string;
    public activeGroupId: string;
    public ctx$: Observable<{
        fixedPrependApplications: ApplicationTile[],
        fixedAppendApplications: ApplicationTile[],
        favorites: ApplicationTile[],
        groups: ApplicationGroupTile[]
    }>;
    public fixedPrependApplications$: Observable<ApplicationTile[]>;
    public fixedAppendApplications$: Observable<ApplicationTile[]>;
    public favorites$: Observable<ApplicationTile[]>;
    public groups$: Observable<ApplicationGroupTile[]>;
    public language: string;
    public trackById = trackBy('id');
    @Input() header: NavHeaderConfig;

    constructor(
        private applicationsService: GaApplicationsService,
        private navService: PipNavService,
        private sessionService: GaSessionService,
        private translate: TranslateService,
    ) {
        this.subs = this.applicationsService.activeApplication$.subscribe(app => {
            this.activeApplicationId = app && app.id;
            this.activeGroupId = app && app.group;
        });
        this.subs = this.translate.onLangChange.asObservable()
            .pipe(startWith({ lang: this.translate.currentLang }))
            .subscribe(l => this.language = l.lang);
        this.fixedPrependApplications$ = this.applicationsService.applications$.pipe(
            map(this.fixedApplicationsFn(this.fixedPrependApplicationsKeys))
        );
        this.fixedAppendApplications$ = this.applicationsService.applications$.pipe(
            map(this.fixedApplicationsFn(this.fixedAppendApplicationsKeys))
        );
        this.favorites$ = this.applicationsService.favorites$;
        this.groups$ = this.applicationsService.groups$.pipe(
            map(groups => groups.filter(g => g.applications && g.applications.length))
        );
        this.ctx$ = combineLatest([
            this.fixedPrependApplications$,
            this.fixedAppendApplications$,
            this.favorites$,
            this.groups$
        ]).pipe(map(([fixedPrependApplications,
            fixedAppendApplications,
            favorites,
            groups]) => ({
                fixedPrependApplications,
                fixedAppendApplications,
                favorites,
                groups
            })));
    }

    ngOnDestroy(): void { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('header')) {
            setTimeout(() => { this.changeHeaders(); }, 0);
        }
    }

    private fixedApplicationsFn(keys: string[]): (apps: ApplicationTile[]) => ApplicationTile[] {
        return (apps: ApplicationTile[]) => {
            const items: ApplicationTile[] = [];
            for (const key of keys) {
                if (apps && apps.length) {
                    const app = apps.find(a => !!a.id.match(key));
                    if (app) {
                        items.push(app);
                        continue;
                    }
                }
                if (this.defaultFixedApplications.hasOwnProperty(key)) {
                    items.push(this.defaultFixedApplications[key]);
                }
            }
            return items;
        };
    }

    private changeHeaders(): void {
        if (!this.header) { return; }

        this.navService.showNavHeader(cloneDeep(this.header));
    }

    public onClick(item: ApplicationTile): void {
        if (item.hasOwnProperty('click')) {
            item.click();
        } else {
            this.applicationsService.navigateToApplication(item);
        }
    }

    public signout(): void {
        this.sessionService.signout();
    }

}
